import { render, staticRenderFns } from "./area-documentation.component.vue?vue&type=template&id=fbb8d33a"
import script from "./area-documentation.component.ts?vue&type=script&lang=ts&external"
export * from "./area-documentation.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fbb8d33a')) {
      api.createRecord('fbb8d33a', component.options)
    } else {
      api.reload('fbb8d33a', component.options)
    }
    module.hot.accept("./area-documentation.component.vue?vue&type=template&id=fbb8d33a", function () {
      api.rerender('fbb8d33a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client/site-setup/site-setup-location-form/area-documentation/area-documentation.component.vue"
export default component.exports